export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/work4.801359ed.svg","height":150,"width":185,"blurWidth":0,"blurHeight":0};